import React from 'react';
import './RSSPostImage.scss';

export default function RSSPostImage({ favicon, children }: { favicon: string; children: React.ReactNode }) {
  return (
    <div className="rss-post-image-container">
      {children}
      {favicon && <img src={favicon} alt="RSS Post" className="rss-post-favicon" />}
    </div>
  );
}
